import { Check, Copy } from "lucide-react";
import { useClipboard } from "@/hooks/use-clipboard.ts";
import { cn } from "@/lib/utils.ts";
import { Button, type ButtonProps } from "@/components/ui/button.tsx";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip.tsx";

export interface CopyButtonProps extends Omit<ButtonProps, "onClick" | "children" | "value"> {
  text?: string;
  value?: string;
  label?: string;
  copiedLabel?: string;
  showLabel?: boolean;
}

export function CopyButton({ text: textProp, value, label = "Copy", copiedLabel = "Copied", showLabel = false, className, variant = "ghost", size, ...props }: CopyButtonProps) {
  const text = textProp ?? value ?? "";
  const { copied, copy } = useClipboard();
  const Icon = copied ? Check : Copy;
  const btn = (
    <Button type="button" variant={variant} size={size ?? (showLabel ? "sm" : "icon-sm")} className={cn(copied && "text-success", className)} aria-label={copied ? copiedLabel : label} onClick={() => void copy(text)} {...props}>
      <Icon className="size-3.5" />
      {showLabel && (copied ? copiedLabel : label)}
    </Button>
  );
  if (showLabel) return btn;
  return (
    <Tooltip>
      <TooltipTrigger asChild>{btn}</TooltipTrigger>
      <TooltipContent>{copied ? copiedLabel : label}</TooltipContent>
    </Tooltip>
  );
}

export default CopyButton;
